"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectGraphData = exports.selectPnl2 = exports.selectPnl = exports.selectGraphEquityOffset = exports.selectDomains = exports.selectIsReducedDomain = exports.selectSettingsChartCalculation = exports.selectPageOperationCurrencyChartCalculation = exports.selectEquitiesChartCalculation = exports.selectTickersChartCalculation = exports.selectIndicesChartCalculation = exports.selectPositionsChartCalculation = exports.selectGraphVisibilityDomain = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const calculationsChart_1 = require("../calculationsChart");
const domainUtils_1 = require("../calculationsChart/domainUtils");
const calculationsCore_1 = require("../calculationsCore");
const types_1 = require("../types");
const pnlCalculations_1 = require("../pnlCalculations");
const utils_1 = require("../utils");
// ----------------------------------------- //
// --------- SELECTORS FROM STATE ---------- //
// ----------------------------------------- //
exports.selectGraphVisibilityDomain = (0, toolkit_1.createSelector)([(state) => state.settings.graphVisibilityDomain], (domain) => domain);
exports.selectPositionsChartCalculation = (0, toolkit_1.createSelector)([(state) => state.positions], (positions) => positions);
exports.selectIndicesChartCalculation = (0, toolkit_1.createSelector)([(state) => state.indices], (indices) => indices);
exports.selectTickersChartCalculation = (0, toolkit_1.createSelector)([(state) => state.tickers], (tickers) => tickers);
exports.selectEquitiesChartCalculation = (0, toolkit_1.createSelector)([(state) => state.equities], (equities) => equities);
exports.selectPageOperationCurrencyChartCalculation = (0, toolkit_1.createSelector)([(state) => state.settings], (settings) => settings.pageOperationCurrency);
exports.selectSettingsChartCalculation = (0, toolkit_1.createSelector)([(state) => state.settings], (settings) => settings);
exports.selectIsReducedDomain = (0, toolkit_1.createSelector)([(state) => state.settings], (settings) => settings.isScrolling);
// ----------------------------------------- //
// ------- END SELECTORS FROM STATE -------- //
// ----------------------------------------- //
/**
 * Returns the domains used for calculations for all currencies.
 */
exports.selectDomains = (0, toolkit_1.createSelector)([
    exports.selectIndicesChartCalculation,
    exports.selectPageOperationCurrencyChartCalculation,
    exports.selectGraphVisibilityDomain,
    exports.selectIsReducedDomain,
    exports.selectPositionsChartCalculation,
], (indices, currency, visibilityDomain, isReducedDomain, positions) => {
    return (0, domainUtils_1.getDomains)(indices, currency, visibilityDomain, isReducedDomain, positions);
});
exports.selectGraphEquityOffset = (0, toolkit_1.createSelector)([
    exports.selectDomains,
    exports.selectEquitiesChartCalculation,
    exports.selectIndicesChartCalculation,
    exports.selectSettingsChartCalculation,
], (domains, equities, indices, settings) => {
    if (settings.pageOperationCurrency === types_1.Currency.ALL) {
        return (0, calculationsChart_1.getEquityOffsetArrayForAll)(domains, equities, indices, settings.chartType, settings.ignoreEquity);
    }
    if (settings.pageOperationCurrency === types_1.Currency.USDC) {
        return (0, calculationsChart_1.getLinearOffset)(domains[types_1.Currency.USDC], settings.chartType, equities[types_1.Currency.USDC].updatedEquity, settings.ignoreEquity);
    }
    const currencyType = settings.graphCalculationCurrency === types_1.Currency.USD
        ? types_1.CurrencyType.FIAT
        : types_1.CurrencyType.CRYPTO;
    return (0, calculationsChart_1.getEquityOffsetArray)(equities[settings.pageOperationCurrency].updatedEquity, indices[settings.pageOperationCurrency], domains[settings.pageOperationCurrency], currencyType, settings.chartType);
});
exports.selectPnl = (0, toolkit_1.createSelector)([
    exports.selectPositionsChartCalculation,
    exports.selectTickersChartCalculation,
    exports.selectDomains,
    exports.selectGraphEquityOffset,
    exports.selectSettingsChartCalculation,
], (positions, tickers, domains, equityOffset, settings) => {
    const currencyType = settings.graphCalculationCurrency === types_1.Currency.USD
        ? types_1.CurrencyType.FIAT
        : types_1.CurrencyType.CRYPTO;
    let offsetArray = new Array(equityOffset.length).fill(0);
    offsetArray = settings.ignoreEquity
        ? offsetArray
        : offsetArray.map((x, i) => equityOffset[i] + offsetArray[i]);
    return (0, calculationsCore_1.getAllCcyPnlSum)(domains, positions, tickers, settings.impliedVolatilityCalculationType, settings.timestamp, currencyType, settings.pageOperationCurrency, settings.isOffsetActive, 1, offsetArray);
});
exports.selectPnl2 = (0, toolkit_1.createSelector)([
    exports.selectPositionsChartCalculation,
    exports.selectTickersChartCalculation,
    exports.selectDomains,
    exports.selectGraphEquityOffset,
    exports.selectSettingsChartCalculation,
], (positions, tickers, domains, equityOffset, settings) => {
    const currencyType = settings.graphCalculationCurrency === types_1.Currency.USD
        ? types_1.CurrencyType.FIAT
        : types_1.CurrencyType.CRYPTO;
    let offsetArray = new Array(equityOffset.length).fill(0);
    offsetArray = settings.ignoreEquity
        ? offsetArray
        : offsetArray.map((x, i) => equityOffset[i] + offsetArray[i]);
    const corePositions = (0, utils_1.mapToCorePositions)(positions);
    const filterDvolOut = corePositions.filter((p) => !p.instrument.includes("DVOL"));
    const domainLength = settings.pageOperationCurrency === types_1.Currency.BTC ||
        settings.pageOperationCurrency === types_1.Currency.ETH
        ? domains[settings.pageOperationCurrency].length
        : domains[types_1.Currency.USDC].length;
    return (0, pnlCalculations_1.calculateGraphLines)(domains, domainLength, filterDvolOut, tickers, settings.isOffsetActive, currencyType, settings.timestamp, new Date().getTime());
});
exports.selectGraphData = (0, toolkit_1.createSelector)([
    exports.selectPnl2,
    exports.selectDomains,
    exports.selectSettingsChartCalculation,
    exports.selectGraphVisibilityDomain,
], (pnlLines, domains, settings, visibilityDomain) => {
    const basicPnlResult = {
        chartLines: Object.assign({}, pnlLines),
        volotilitySmile: [],
        xAxisValues: domains[settings.pageOperationCurrency],
        isExternalViewPort: visibilityDomain === undefined,
    };
    return basicPnlResult;
});
